<template>
  <div v-if="languages?.length" class="flex flex-wrap gap-6">
    <div
      v-for="language in languages"
      :key="language.id"
      class="flex items-center gap-2"
    >
      <img
        v-if="language.image_url"
        :src="language.image_url"
        :alt="language.name"
        class="h-[18px] w-6 rounded-sm object-cover"
      >
      <span
        v-else
        class="inline-flex h-[18px] w-6 items-center justify-center rounded-sm bg-neutral-100 text-[10px] font-semibold text-neutral-500"
      >
        {{ languageInitial(language.name) }}
      </span>
      <span class="text-base font-medium leading-[18px] text-neutral-900">
        {{ language.name }}
      </span>
    </div>
  </div>
</template>

<script setup>
defineProps({
  languages: {
    type: Array,
    default: () => [],
  },
});

function languageInitial(name) {
  return (name || '?').trim().charAt(0).toUpperCase();
}
</script>
